module.exports = __webpack_public_path__ + "static/assets/11b94a80c0b2f8cfcc3cc9973bd969a6.png";